
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface UsersFilterProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  filterAdmin: string;
  onFilterChange: (value: string) => void;
}

export function UsersFilter({
  searchTerm,
  onSearchChange,
  filterAdmin,
  onFilterChange,
}: UsersFilterProps) {
  return (
    <div className="flex gap-4 mb-4">
      <div className="flex-1">
        <div className="relative">
          <Search className="absolute left-2 top-2.5 h-4 w-4 text-muted-foreground" />
          <Input
            placeholder="Zoek op e-mail..."
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            className="pl-8"
          />
        </div>
      </div>
      <Select
        value={filterAdmin}
        onValueChange={onFilterChange}
      >
        <SelectTrigger className="w-[180px]">
          <SelectValue placeholder="Filter op rol" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Alle gebruikers</SelectItem>
          <SelectItem value="admin">Alleen admins</SelectItem>
          <SelectItem value="user">Alleen gebruikers</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}
